import { createEntityAdapter } from '@reduxjs/toolkit';

const adapter = createEntityAdapter({
  sortComparer: (a, b) => b.id - a.id,
});

export default adapter;
